<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link class="btn btn-sm" :to="{ name: 'MacbindingList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Macbindings
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Macbindings</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Macbinding">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header py-3">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      name="accountId"
                      class="form-control accountId"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Device MAC</label>
                    <input
                      type="text"
                      id="mac"
                      name="mac"
                      v-bind:class="{ 'has-error': errors.has('mac') }"
                      pattern="^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$"
                      :readonly="is_edit"
                      v-validate="'required'"
                      v-model="value.mac"
                      class="form-control mac"
                      placeholder="Example: 44:D1:FA:2C:93:86"
                    />
                    <div class="help text-danger" v-show="errors.has('mac')">
                      {{ `The device mac is required in proper mac address format.` }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">IP Address</label>
                    <input
                      type="text"
                      id="ip"
                      name="ip"
                      v-bind:class="{ 'has-error': errors.has('ip') }"
                      :readonly="is_edit"
                      v-validate="'required|ip'"
                      v-model="value.ip"
                      class="form-control ip"
                      placeholder="Example: 192.168.20.100"
                    />
                    <div class="help text-danger" v-show="errors.has('ip')">
                      {{ `The IP addres is required in proper IP address format.` }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="devicename"
                      name="Name"
                      v-bind:class="{ 'has-error': errors.has('devicename') }"
                      v-validate="'required'"
                      :readonly="is_edit"
                      v-model="value.devicename"
                      class="form-control devicename"
                      placeholder="Name"
                    />
                    <div class="help text-danger" v-show="errors.has('Name')">
                      {{ errors.first("Name") }}
                    </div>
                  </div>

                  <div v-if="is_edit" class="form-group required">
                    <label class="control-label">Status</label>
                    <multiselect
                      v-model="value.mstatus"
                      :options="Object.keys(pre.status)"
                      :allow-empty="false"
                      :custom-label="(opt) => pre.status[opt]"
                      placeholder=""
                      :searchable="true"
                      deselect-label=""
                      :multiple="false"
                      id="mstatus"
                      v-bind:class="{ 'has-error': errors.has('mstatus') }"
                      v-validate="'required'"
                      name="mstatus"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('mstatus')">
                      {{ errors.first("mstatus") }}
                    </div>
                  </div>

                  <div v-if="is_edit" class="form-group required d-none">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <label class="switch-label">ENABLED</label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          name="mstatus"
                          v-model="value.mstatus"
                          id="mstatus"
                          :value="Object.keys(pre.status)"
                          v-validate="'required'"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import LocalStorage from "@/services/localStorage";
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "MacbindingForm",
  metaInfo: {
    title: "Macbindings | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      status: { Enabled: "ENABLED", Disabled: "DISABLED" },
      audraName: [],
    },
  }),
  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/macbinding";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/macbinding/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "MacbindingList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/macbinding/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
